import $ from 'jquery';

$('body').on('click', '.js-context-menu-toggle', (ev) => {
    ev.preventDefault();
    const $contextMenuToggle = $(ev.currentTarget);
    const $contextMenu = $contextMenuToggle.closest('.js-context-menu');
    const $otherMenus = $('.js-context-menu.is-active').not($contextMenu);
    if ($contextMenu.hasClass('is-active')) {
        $contextMenu.removeClass('is-active');
        $contextMenuToggle.attr('aria-expanded', 'false');
    } else {
        $otherMenus.removeClass('is-active');
        $('.js-context-menu-toggle', $otherMenus).attr('aria-expanded', 'false');
        $contextMenu.addClass('is-active');
        $contextMenuToggle.attr('aria-expanded', 'true');
    }
});

$(document).on('click', (ev) => {
    const $contextMenu = $('.js-context-menu');
    if ($contextMenu.hasClass('is-active') && !$(ev.target).closest('.js-context-menu').length) {
        $contextMenu.removeClass('is-active');
        $('.js-context-menu-toggle', $contextMenu).attr('aria-expanded', 'false');
    }
});
